import { View } from 'react-native';
import { IllustrativeAdCard } from './discovery-parts';
import { IllustrationFrame, type IllustrationProps } from './illustration-parts';
import { illustrationPalette as palette } from './illustration-palette';
import type { IllustrationScale } from './illustration-scene';

function SearchResults({ s }: { s: IllustrationScale }) {
  const ads = [
    { tone: 'clay', breed: 'breed_labrador' },
    { tone: 'olive', breed: 'breed_ragdoll' },
    { tone: 'cream', breed: 'breed_poodle' },
    { tone: 'forest', breed: 'breed' },
  ] as const;
  return (
    <View className="flex-row flex-wrap" style={{ gap: s(8) }}>
      {ads.map(({ tone, breed }) => (
        <IllustrativeAdCard
          key={breed}
          s={s}
          width={60}
          photoHeight={34}
          tone={tone}
          breedKey={breed}
          compact
        />
      ))}
    </View>
  );
}

export function Browse({ transparent = false }: IllustrationProps) {
  const zoom = 1.18;
  return (
    <IllustrationFrame transparent={transparent}>
      {(s) => (
        <>
          <View
            testID="search-ad-grid"
            className="absolute"
            style={{ left: s(16), top: s(7), width: s(128) }}
          >
            <SearchResults s={s} />
          </View>
          <View
            className="absolute rounded-full"
            style={{
              left: s(123.5),
              top: s(141),
              width: s(6),
              height: s(17),
              backgroundColor: palette.forest,
              transform: [{ rotate: '-40deg' }],
            }}
          />
          <View
            testID="search-magnifier"
            className="absolute overflow-hidden rounded-full"
            style={{
              left: s(80),
              top: s(102),
              width: s(48),
              height: s(48),
              borderWidth: s(2.3),
              borderColor: palette.ink,
              backgroundColor: palette.paper,
            }}
          >
            {/* Uniformly magnify the same grid around the optical centre. */}
            <View
              className="absolute"
              style={{
                left: s(21.7 - (104 - 16) * zoom),
                top: s(21.7 - (126 - 7) * zoom),
                width: s(128 * zoom),
              }}
            >
              <SearchResults s={(value) => s(value * zoom)} />
            </View>
          </View>
        </>
      )}
    </IllustrationFrame>
  );
}
